import React from "react";

import {
  verticalProductCardContent,
  verticalProductCardPricingSection,
  verticalProductCardSpacer
} from "../components/VerticalProductCard.css";
import {
  ProductCardDataType,
  VerticalProductCard as ProductCard
} from "../components/index";

type Props = {
  productCardData: ProductCardDataType;
  onButtonClick?: () => void;
  onShadeSelectorClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onWishlistToggle?: (productCardData: ProductCardDataType) => void;
  onCardClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
  ) => void;
  buttonVariant?: "primary" | "secondary";
  disableLink?: boolean;
};

export const StandardVerticalProductCard = React.forwardRef<
  HTMLDivElement | HTMLAnchorElement,
  Props
>(
  (
    {
      productCardData,
      onButtonClick,
      onShadeSelectorClick,
      onWishlistToggle,
      onCardClick,
      buttonVariant,
      disableLink
    },
    ref
  ) => {
    return (
      <ProductCard
        product={productCardData}
        onClick={onCardClick}
        disableLink={disableLink}
        ref={ref}
      >
        <ProductCard.Header>
          <ProductCard.Badge product={productCardData} />
          <ProductCard.Ribbon product={productCardData} />
          <ProductCard.Image product={productCardData} />
          {onWishlistToggle && (
            <ProductCard.Wishlist
              product={productCardData}
              onToggle={onWishlistToggle}
            />
          )}
        </ProductCard.Header>

        <ProductCard.Body>
          <div className={verticalProductCardContent}>
            <ProductCard.Rating product={productCardData} />
            <ProductCard.BrandName product={productCardData} />
            <ProductCard.ProductName product={productCardData} />
            {/* Temporarily removing for smoke test due to issues around it showing data when it shouldn't */}
            {/* <ProductCard.VariationName product={productCardData} /> */}
          </div>
          <div className={verticalProductCardSpacer} />
          <div className={verticalProductCardPricingSection}>
            {(productCardData.swatchImages?.length ?? 0) > 0 && (
              <ProductCard.ColorSwatch
                product={productCardData}
                onClick={onShadeSelectorClick}
              />
            )}
          </div>
          <ProductCard.Pricing
            product={productCardData}
          />
        </ProductCard.Body>

        <ProductCard.Footer>
          {onButtonClick && (
            <ProductCard.Button
              product={productCardData}
              onClick={onButtonClick}
              variant={buttonVariant}
            />
          )}
        </ProductCard.Footer>
      </ProductCard>
    );
  }
);
